import { Box, CardMedia, Grid, Typography } from "@mui/material";

import iconUrl from "@/assets/icons/home/new-way/chart-bar.svg";
import imageStatUrl from "@/assets/images/home/new-way/statistics.png";
import imageScoreUrl from "@/assets/images/home/new-way/score.png";
import useResponsive from "@/hooks/useResponsive";

import Label from "./Label";
import {
  imageScoreStyles,
  imageStatStyles,
  imageWrapperScoreStyles,
  imageWrapperStatStyles,
} from "./styles";

const Statistics = () => {
  const isDesktop = useResponsive("up", "lg");

  return (
    <Box
      bgcolor="white"
      borderRadius={3}
      p={{ xs: 2, md: 5, xl: 7.5 }}
      sx={{ boxShadow: "0 24px 48px -12px rgba(93,97,104,.1)" }}
    >
      <Grid
        container
        columnSpacing={{ xs: 0, md: 3, lg: 5, xl: 19 }}
        sx={{
          minHeight: { md: 335, lg: 378, xl: 402 },
        }}
      >
        <Grid item xs={12} md={6} lg={5.5}>
          <Label label="Statistics" iconUrl={iconUrl} />
          <Typography
            variant="h3"
            fontSize={{ xs: "1.25rem", md: "2rem", lg: "2.5rem" }}
            mb={2}
          >
            Keep an eye on driver behavior{" "}
            <Typography
              variant="h4"
              component="span"
              fontSize="inherit !important"
              fontWeight="inherit !important"
              fontFamily="inherit !important"
              color="text.accent"
            >
              ratings
            </Typography>
          </Typography>
          <Typography
            color="text.secondary"
            variant="body1"
            mb={{ xs: 3, md: 0 }}
          >
            Our advanced tracking technology goes beyond location monitoring,
            providing insightful data on driver performance.
          </Typography>
        </Grid>

        <Grid item xs={12} md={6} lg={6.5}>
          <Box
            display="flex"
            gap={{ xs: 1, lg: 3 }}
            justifyContent={{ xs: "center", md: "end" }}
            alignItems="center"
            height="100%"
          >
            <Box>
              {isDesktop && (
                <Box sx={imageWrapperScoreStyles}>
                  <CardMedia
                    component="img"
                    image={imageScoreUrl}
                    alt="image"
                    loading="lazy"
                    sx={imageScoreStyles}
                  />
                </Box>
              )}
            </Box>
            <Box px={{ lg: 2 }} py={{ lg: 2.6 }} sx={imageWrapperStatStyles}>
              <CardMedia
                component="img"
                loading="lazy"
                image={imageStatUrl}
                alt="image"
                sx={imageStatStyles}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Statistics;
